import { Link } from "react-router-dom";
import { CTAButtons } from "@/components/chrome";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-3xl px-5 py-24 sm:py-32" data-testid="not-found-page">
      <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-cyan-700">404</p>
      <h1 className="mt-4 font-display text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">
        This page moved. Your space can still get clean.
      </h1>
      <p className="mt-5 max-w-xl leading-relaxed text-slate-600">
        The page you're looking for doesn't exist — but our crews are still one call away in 150+ Canadian cities.
      </p>
      <CTAButtons className="mt-8" prefix="notfound" />
      <div className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm">
        <Link to="/" className="font-semibold text-cyan-700 transition-colors hover:text-cyan-800">Home</Link>
        <Link to="/services" className="font-semibold text-cyan-700 transition-colors hover:text-cyan-800">All services</Link>
        <Link to="/locations" className="font-semibold text-cyan-700 transition-colors hover:text-cyan-800">All locations</Link>
      </div>
    </div>
  );
}
